import Checkbox from '@mui/material/Checkbox';
import { renderCellExpand } from 'components/Common/GridCell/GridCellExpand';

export const attendanceCourseColumns = (
  selectedIds = [],
  handleToggleSelect,
  isLive = false,
) => {
  const baseColumns = [
    {
      field: 'select',
      headerName: '',
      width: 55,
      sortable: false,
      disableColumnMenu: true,
      align: 'center',
      headerAlign: 'center',

      renderHeader: () => null,

      renderCell: (params) => (
        <Checkbox
          checked={selectedIds.includes(params?.row?.id)}
          onChange={(e) =>
            handleToggleSelect(params?.row?.id, e?.target?.checked)
          }
        />
      ),
    },
    {
      width: 200,
      field: 'courseName',
      headerName: 'Course Name',
      renderCell: renderCellExpand,
    },
    {
      width: 85,
      headerName: 'Days',
      renderCell: renderCellExpand,
      field: 'numSchoolDaysSinceOnline',
    },
    {
      width: 90,
      headerName: 'Grade',
      field: 'actualGrade',
      renderCell: renderCellExpand,
    },
    {
      width: 150,
      headerName: 'Last Online',
      field: 'lastOnlineActivity',
      renderCell: renderCellExpand,
    },
  ];

  // ✅ INSERT LIVE COLUMNS RIGHT AFTER Course Name
  if (isLive) {
    const liveColumns = [
      {
        width: 95,
        type: 'number',
        field: 'liveDays',
        headerName: 'Days (Live)',
        renderCell: renderCellExpand,
      },
      {
        width: 95,
        field: 'liveGrade',
        headerName: 'Grade (Live)',
        renderCell: renderCellExpand,
      },
      {
        width: 150,
        field: 'liveLastActivity',
        renderCell: renderCellExpand,
        headerName: 'Last Activity (Live)',
      },
    ];

    baseColumns.splice(2, 0, ...liveColumns);
  }

  return baseColumns;
};
